/* Herramientas gratis de lineagrafica.es (repo LINEA-GRAFICA/lg-web-tools, carpeta tema/).
   Monta la interfaz de la sección lg-tool: validador VIES, comprobador UE, generador del aviso de garantía y calculadora del plazo de garantía. */
(function () {
  var root = document.querySelector('[data-lgt]');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var LANG = root.getAttribute('data-lang') || 'es';
  var ALL = window.LGT_I18N || {};
  var T = ALL[LANG] || ALL[LANG.split('-')[0]] || ALL.es || {};
  var BASE = ALL.es || {};
  var APPS = json(root.getAttribute('data-apps'));
  var GUIDES = json(root.getAttribute('data-guides'));
  var app = root.querySelector('[data-lgt-app]');
  var tool = root.getAttribute('data-tool');

  function json(s) { try { return JSON.parse(s || '{}') || {}; } catch (e) { return {}; } }
  function t(ruta, vars) {
    var get = function (o) { return ruta.split('.').reduce(function (a, k) { return a && a[k] != null ? a[k] : undefined; }, o); };
    var s = get(T);
    if (s == null) s = get(BASE);
    if (s == null) s = '';
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function region(cc, lang) {
    try { return new Intl.DisplayNames([lang || LANG], { type: 'region' }).of(cc === 'EL' ? 'GR' : cc === 'XI' ? 'GB' : cc) || cc; } catch (e) { return cc; }
  }
  function fecha(iso) {
    try { return new Date(iso).toLocaleString(LANG, { dateStyle: 'long', timeStyle: 'short' }); } catch (e) { return iso; }
  }
  function api(ruta) {
    return fetch(API + ruta + (ruta.indexOf('?') < 0 ? '?' : '&') + 'lang=' + encodeURIComponent(LANG), { credentials: 'omit' })
      .then(function (r) { if (r.status === 429) return { ok: false, error: 'rate' }; return r.json(); });
  }
  function errorTexto(e, grupo) {
    if (e === 'rate') return t(grupo + '.error_rate') || t('common.error_rate');
    var s = t(grupo + '.error_' + e);
    return s || t('common.error_generic');
  }
  function copiar(btn, texto) {
    var fin = function () { var o = btn.textContent; btn.textContent = t('common.copied'); setTimeout(function () { btn.textContent = o; }, 1600); };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(texto).then(fin, fin);
    else { var a = document.createElement('textarea'); a.value = texto; document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} a.remove(); fin(); }
  }
  function upsell(titulo, texto, url) {
    if (!url) return '';
    return '<div class="lgt__upsell"><div><h3>' + esc(titulo) + '</h3><p>' + esc(texto) + '</p></div>' +
      '<a class="lgt__btn" href="' + esc(url) + '">' + esc(t('common.app_cta')) + '</a></div>';
  }
  var disc = '<p class="lgt__disc">' + esc(t('common.disclaimer')) + '</p>';
  var lead = root.querySelector('[data-lgt-lead]');
  if (lead) lead.innerHTML = '<span class="lgt__badge">' + esc(t('common.free')) + '</span><br>' + esc(t(tool + '.lead'));

  /* ---------- Validador VIES ---------- */
  // Bajo el validador: «hazlo solo en cada pedido B2B» para Shopify (App Store con UTM) y PrestaShop (módulo lgvatoss).
  function viesB2b() {
    var store = 'https://apps.shopify.com/vies-libre-de-impuestos-facil?utm_source=lineagrafica&utm_medium=web&utm_campaign=vies&utm_content=comprobador-vies-' + encodeURIComponent(LANG);
    var tarjeta = function (k, url) {
      if (!url) return '';
      return '<div class="lgt__b2b-card"><h3>' + esc(t('vies.' + k + '_title')) + '</h3><p>' + esc(t('vies.' + k + '_text')) + '</p>' +
        '<a class="lgt__btn" data-lgt-b2b="' + k + '" href="' + esc(url) + '"' + (k === 'shopify' ? ' target="_blank" rel="noopener"' : '') + '>' + esc(t('vies.' + k + '_cta')) + '</a></div>';
    };
    return '<section class="lgt__b2b"><h2>' + esc(t('vies.b2b_title')) + '</h2><div class="lgt__b2b-grid">' +
      tarjeta('shopify', store) + tarjeta('prestashop', APPS.vies_ps) + '</div><p class="lgt__b2b-trust">' + esc(t('vies.trust')) + '</p></section>';
  }
  app.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-lgt-b2b]');
    if (a && typeof window.gtag === 'function') window.gtag('event', 'lg_tool_cta', { tool: tool, platform: a.getAttribute('data-lgt-b2b'), lang: LANG });
  });
  // Bajo el resultado: «¿Vendes en Shopify?» → ficha de la App Store en el idioma de la página (utm_content aparte para medirlo).
  function viesResultado() {
    var loc = { es: 'es', de: 'de', fr: 'fr', it: 'it', nl: 'nl', 'pt-PT': 'pt-PT' }[LANG];
    var url = 'https://apps.shopify.com/vies-libre-de-impuestos-facil?' + (loc ? 'locale=' + loc + '&' : '') +
      'utm_source=lineagrafica&utm_medium=web&utm_campaign=vies&utm_content=comprobador-vies-resultado-' + encodeURIComponent(LANG);
    return '<div class="lgt__upsell"><div><h3>' + esc(t('vies.result_shopify_title')) + '</h3><p>' + esc(t('vies.result_shopify_text')) + '</p></div>' +
      '<a class="lgt__btn" data-lgt-b2b="shopify-resultado" href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(t('vies.result_shopify_cta')) + '</a></div>';
  }
  function vies() {
    app.innerHTML = '<form class="lgt__form" novalidate><div class="lgt__field"><label for="lgt-vat">' + esc(t('vies.label')) + '</label>' +
      '<input id="lgt-vat" type="text" autocomplete="off" spellcheck="false" maxlength="20" placeholder="' + esc(t('vies.placeholder')) + '"></div>' +
      '<button class="lgt__btn" type="submit">' + esc(t('vies.button')) + '</button></form>' +
      '<p class="lgt__note">' + esc(t('vies.privacy')) + '</p><div data-out aria-live="polite"></div>' + viesB2b() + disc;
    var form = app.querySelector('form'), input = app.querySelector('input'), btn = app.querySelector('button'), out = app.querySelector('[data-out]');
    var q = new URLSearchParams(location.search).get('vat');
    if (q) input.value = q.slice(0, 20);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = input.value.trim();
      if (!v) { input.focus(); return; }
      btn.disabled = true;
      out.innerHTML = '<div class="lgt__msg">' + esc(t('common.loading')) + '</div>';
      api('/api/vies?vat=' + encodeURIComponent(v)).then(function (r) {
        if (!r.ok) {
          var m = r.error === 'format' ? t('vies.error_format', { country: region(r.countryCode) }) : errorTexto(r.error, 'vies');
          out.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(m) + '</div>';
          return;
        }
        var h = '<div class="lgt__result lgt__result--' + (r.valid ? 'ok' : 'bad') + '"><h2>' + (r.valid ? '✓ ' : '✗ ') + esc(t(r.valid ? 'vies.valid' : 'vies.invalid')) + '</h2>' +
          '<p class="lgt__meta">' + esc(r.countryCode + r.vatNumber) + ' · ' + esc(region(r.countryCode)) + '</p>';
        if (r.valid) {
          h += '<dl class="lgt__dl">';
          if (r.name || r.address) {
            if (r.name) h += '<dt>' + esc(t('vies.name')) + '</dt><dd>' + esc(r.name) + '</dd>';
            if (r.address) h += '<dt>' + esc(t('vies.address')) + '</dt><dd>' + esc(r.address) + '</dd>';
          } else h += '<dd style="grid-column:1/-1">' + esc(t('vies.not_published')) + '</dd>';
          h += '<dt>' + esc(t('vies.date')) + '</dt><dd>' + esc(fecha(r.requestDate)) + '</dd></dl>';
        } else h += '<p>' + esc(t('vies.invalid_help')) + '</p>';
        h += '</div>' + viesResultado();
        out.innerHTML = h;
      }).catch(function () {
        out.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(t('common.error_generic')) + '</div>';
      }).then(function () { btn.disabled = false; });
    });
  }

  /* ---------- Comprobador UE ---------- */
  var APP_DE = { withdrawal: 'withdrawal', guarantee: 'guarantee', vat: 'vies', ai_refund: 'withdrawal', ai_terms: 'guarantee', ai_shipping: 'faq' };
  function evidencia(c) {
    var e = c.evidence;
    if (!e || e === 'app' || e === 'notice') return '';
    if (Array.isArray(e)) {
      if (!e.length) return '';
      return '<div class="lgt__ev"><strong>' + esc(t('check.evidence')) + ':</strong><ul>' + e.map(function (h) {
        return '<li><strong>' + esc(h.term) + '</strong> · ' + esc(h.where === 'home' ? '/' : h.where) + ' — «' + esc(h.text) + '»</li>';
      }).join('') + '</ul></div>';
    }
    return '<div class="lgt__ev"><strong>' + esc(t('check.evidence')) + ':</strong> «' + esc(String(e).slice(0, 160)) + '»' +
      (c.product ? ' · ' + esc(c.product) : '') + '</div>';
  }
  function check() {
    app.innerHTML = '<form class="lgt__form" novalidate><div class="lgt__field"><label for="lgt-url">' + esc(t('check.label')) + '</label>' +
      '<input id="lgt-url" type="text" inputmode="url" autocomplete="off" spellcheck="false" maxlength="200" placeholder="' + esc(t('check.placeholder')) + '"></div>' +
      '<button class="lgt__btn" type="submit">' + esc(t('check.button')) + '</button></form><div data-out aria-live="polite"></div>' + disc;
    var form = app.querySelector('form'), input = app.querySelector('input'), btn = app.querySelector('button'), out = app.querySelector('[data-out]');
    var q = new URLSearchParams(location.search).get('url');
    if (q) input.value = q.slice(0, 200);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = input.value.trim();
      if (!v) { input.focus(); return; }
      btn.disabled = true;
      out.innerHTML = '<div class="lgt__msg">' + esc(t('check.scanning')) + '</div>';
      api('/api/check?url=' + encodeURIComponent(v)).then(function (r) {
        if (!r.ok) { out.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(errorTexto(r.error, 'check')) + '</div>'; return; }
        var marcador = function (lista) {
          var cuentan = lista.filter(function (c) { return c.status !== 'na' && c.status !== 'info'; });
          var ok = cuentan.filter(function (c) { return c.status === 'ok'; }).length;
          return '<div class="lgt__score"><strong>' + esc(t('check.summary', { ok: ok, total: cuentan.length })) + '</strong>' +
            '<div class="lgt__bar"><span style="width:' + (cuentan.length ? Math.round(100 * ok / cuentan.length) : 0) + '%"></span></div></div>' +
            (lista.length > cuentan.length ? '<p class="lgt__meta">' + esc(t('check.summary_note', { n: lista.length - cuentan.length, all: lista.length })) + '</p>' : '');
        };
        var item = function (c) {
          var k = 'check.items.' + c.id + '.';
          var st = c.reason ? c.status + '_' + c.reason : c.status;
          var msg = t(k + st, { n: c.products, total: c.scanned }) || t(k + c.status, { n: c.products, total: c.scanned });
          if (!msg && c.status === 'warn') msg = t(k + 'fail');
          var links = [];
          if (c.status !== 'ok' && c.status !== 'na') {
            var appUrl = APPS[APP_DE[c.id]];
            if (appUrl && t(k + 'app')) links.push('<a class="lgt__applink" href="' + esc(appUrl) + '">' + esc(t(k + 'app')) + '</a>');
            if (GUIDES[c.id]) links.push('<a href="' + esc(GUIDES[c.id]) + '">' + esc(t('check.guide')) + '</a>');
          }
          return '<li class="lgt__item lgt__item--' + c.status + '"><h3>' + esc(t(k + 'title')) + ' <span class="lgt__pill lgt__pill--' + c.status + '">' + esc(t('check.status.' + st) || t('check.status.' + c.status)) + '</span></h3>' +
            (t(k + 'law') ? '<p class="lgt__law">' + esc(t(k + 'law')) + '</p>' : '') + '<p>' + esc(msg) + '</p>' + evidencia(c) +
            (c.status !== 'ok' && c.status !== 'na' ? '<p><strong>' + esc(t('check.fix')) + ':</strong> ' + esc(t(k + 'fix')) + '</p>' : '') +
            (links.length ? '<div class="lgt__links">' + links.join('') + '</div>' : '') + '</li>';
        };
        var h = marcador(r.checks) +
          '<p class="lgt__meta">' + esc(t('check.store')) + ': ' + esc(r.meta.title || r.meta.host) + ' (' + esc(r.meta.host) + ')</p>';
        if (r.meta.country) h += '<p class="lgt__meta">' + esc(t('check.country_note', { country: region(r.meta.country) })) + '</p>';
        h += '<ul class="lgt__items">' + r.checks.map(item).join('') + '</ul>';
        if (r.agents && r.agents.length && t('check.ai_title')) {
          h += '<h2 class="lgt__h2" id="agentes-ia">' + esc(t('check.ai_title')) + '</h2><p class="lgt__meta">' + esc(t('check.ai_lead')) + '</p>' +
            marcador(r.agents) + '<ul class="lgt__items">' + r.agents.map(item).join('') + '</ul>';
        }
        h += '<div class="lgt__upsell"><div><h3>' + esc(t('check.cta_title')) + '</h3><p>' + esc(t('check.cta_text')) + '</p></div>' +
          '<a class="lgt__btn" href="#contacto">' + esc(t('check.cta_contact')) + '</a></div>';
        out.innerHTML = h;
      }).catch(function () {
        out.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(t('common.error_generic')) + '</div>';
      }).then(function () { btn.disabled = false; });
    });
  }

  /* ---------- Generador del aviso de garantía ---------- */
  var UE = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
  var EEE = ['IS', 'LI', 'NO'];
  var PAIS_IDIOMA = { es: 'ES', en: 'IE', fr: 'FR', de: 'DE', it: 'IT', pl: 'PL', pt: 'PT' };
  function anios(textos, n, lang) {
    var cat = 'other';
    try { cat = new Intl.PluralRules(lang).select(n); } catch (e) {}
    var y = textos.years || {};
    return String(y[cat] || y.other || y.many || '{{ count }}').replace('{{ count }}', n);
  }
  function garantia() {
    app.innerHTML = '<div class="lgt__msg">' + esc(t('common.loading')) + '</div>';
    api('/api/garantia.json').then(function (d) {
      if (!d || !d.texts) throw new Error('datos');
      montarGarantia(d);
    }).catch(function () { app.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(t('common.error_generic')) + '</div>'; });
  }
  function montarGarantia(d) {
    var base = LANG.split('-')[0];
    var idiomas = Object.keys(d.texts).sort(function (a, b) {
      var n = function (x) { try { return new Intl.DisplayNames([LANG], { type: 'language' }).of(x); } catch (e) { return x; } };
      return n(a).localeCompare(n(b), LANG);
    });
    var nombreIdioma = function (x) { try { var s = new Intl.DisplayNames([LANG], { type: 'language' }).of(x); return s.charAt(0).toUpperCase() + s.slice(1); } catch (e) { return x; } };
    var porNombre = function (a, b) { return region(a).localeCompare(region(b), LANG); };
    var casilla = function (cc) {
      return '<label><input type="checkbox" value="' + cc + '"' + (cc === PAIS_IDIOMA[base] ? ' checked' : '') + '> ' + esc(region(cc)) + '</label>';
    };
    app.innerHTML = '<div class="lgt__row"><div><label class="lgt__label" for="lgt-lang">' + esc(t('garantia.lang')) + '</label><select id="lgt-lang">' +
      idiomas.map(function (x) { return '<option value="' + x + '"' + (x === base ? ' selected' : '') + '>' + esc(nombreIdioma(x)) + '</option>'; }).join('') + '</select></div>' +
      '<div><label class="lgt__label" for="lgt-com">' + esc(t('garantia.commercial')) + '</label><input id="lgt-com" type="number" min="0" max="30" step="1" inputmode="numeric"></div></div>' +
      '<span class="lgt__label">' + esc(t('garantia.countries')) + '</span>' +
      '<div class="lgt__checks"><label><input type="checkbox" data-all> ' + esc(t('garantia.all_eu')) + '</label><label><input type="checkbox" data-eea> ' + esc(t('garantia.eea')) + '</label></div>' +
      '<div class="lgt__grid" data-ue>' + UE.slice().sort(porNombre).map(casilla).join('') + '</div>' +
      '<div class="lgt__grid" data-eeagrid hidden>' + EEE.slice().sort(porNombre).map(casilla).join('') + '</div>' +
      '<div data-out aria-live="polite"></div>' + disc;
    var sel = app.querySelector('#lgt-lang'), com = app.querySelector('#lgt-com'), all = app.querySelector('[data-all]'), eea = app.querySelector('[data-eea]');
    var gridEea = app.querySelector('[data-eeagrid]'), out = app.querySelector('[data-out]');
    all.addEventListener('change', function () { app.querySelectorAll('[data-ue] input').forEach(function (i) { i.checked = all.checked; }); pintar(); });
    eea.addEventListener('change', function () { gridEea.hidden = !eea.checked; gridEea.querySelectorAll('input').forEach(function (i) { i.checked = eea.checked; }); pintar(); });
    app.addEventListener('change', function (e) { if (e.target !== all && e.target !== eea) pintar(); });
    com.addEventListener('input', pintar);

    function pintar() {
      var lang = sel.value, tx = d.texts[lang] || d.texts.en;
      var paises = Array.prototype.map.call(app.querySelectorAll('.lgt__grid input:checked'), function (i) { return i.value; })
        .filter(function (cc) { return !gridEea.hidden || EEE.indexOf(cc) < 0; })
        .sort(function (a, b) { return region(a, lang).localeCompare(region(b, lang), lang); });
      var nCom = Math.max(0, Math.min(30, parseInt(com.value, 10) || 0));
      var img = API + '/notice/' + lang + '.png';
      var lineas = paises.filter(function (cc) { return d.legal[cc] && d.legal[cc].years > 0; })
        .map(function (cc) { return region(cc, lang) + ': ' + anios(tx, d.legal[cc].years, lang); });
      if (nCom) lineas.push(tx.commercial + ': ' + anios(tx, nCom, lang));
      var alt = tx.summary;
      var htmlCode = '<div class="eu-guarantee-notice" lang="' + lang + '" style="max-width:300px">\n' +
        '  <img src="' + img + '" alt="' + esc(alt) + '" width="300" style="width:100%;height:auto;display:block">\n' +
        (lineas.length ? '  <p style="margin:8px 0 0;font-weight:600">' + esc(cap(tx.legal)) + '</p>\n  <ul style="margin:4px 0 0;padding-left:18px">\n' + lineas.map(function (l) { return '    <li>' + esc(l) + '</li>\n'; }).join('') + '  </ul>\n' : '') +
        '</div>';
      var textoPlano = tx.summary + (lineas.length ? '\n' + cap(tx.legal) + ':\n' + lineas.map(function (l) { return '- ' + l; }).join('\n') : '');
      var txPagina = d.texts[base] || d.texts.en;
      var filas = paises.map(function (cc) {
        var l = d.legal[cc] || {};
        var plazo = l.years > 0 ? anios(txPagina, l.years, LANG) : t('garantia.years_none');
        return '<tr><td>' + esc(region(cc)) + '</td><td>' + esc(plazo) + (l.ok === false ? ' <em>(' + esc(t('garantia.unconfirmed')) + ')</em>' : '') + '</td>' +
          '<td>' + (l.lawUrl ? '<a href="' + esc(l.lawUrl) + '" target="_blank" rel="noopener nofollow">' + esc(l.law) + '</a>' : esc(l.law || '')) + '</td>' +
          '<td>' + (l.source ? '<a href="' + esc(l.source) + '" target="_blank" rel="noopener nofollow">' + esc(t('garantia.source')) + '</a>' : '') + '</td></tr>';
      }).join('');
      out.innerHTML = '<h3 style="margin:24px 0 4px">' + esc(t('garantia.preview')) + '</h3>' +
        '<div class="lgt__preview"><div class="lgt__notice" lang="' + lang + '"><img src="' + esc(img) + '" alt="' + esc(alt) + '" width="300">' +
        (lineas.length ? '<p style="margin:8px 0 0;font-weight:600">' + esc(cap(tx.legal)) + '</p><ul>' + lineas.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' : '') + '</div>' +
        '<div style="flex:1 1 260px"><p style="margin:0 0 10px;font-size:14.5px">' + esc(t('garantia.where')) + '</p>' +
        '<a class="lgt__btn lgt__btn--ghost" href="' + esc(img) + '" download="eu-guarantee-notice-' + lang + '.png">' + esc(t('common.download')) + ' PNG</a></div></div>' +
        (filas ? '<div class="lgt__tablewrap"><table class="lgt__table"><thead><tr><th>' + esc(t('garantia.countries')) + '</th><th>' + esc(txPagina.legal) + '</th><th>' + esc(t('garantia.law')) + '</th><th>' + esc(t('garantia.source')) + '</th></tr></thead><tbody>' + filas + '</tbody></table></div>' : '') +
        '<h3 style="margin:24px 0 6px">' + esc(t('garantia.html')) + '</h3><textarea class="lgt__code" readonly data-html aria-label="' + esc(t('garantia.html')) + '"></textarea>' +
        '<button class="lgt__btn lgt__btn--ghost" type="button" data-copy="html">' + esc(t('common.copy')) + '</button>' +
        '<h3 style="margin:24px 0 6px">' + esc(t('garantia.text')) + '</h3><textarea class="lgt__code" readonly data-text aria-label="' + esc(t('garantia.text')) + '" style="min-height:110px"></textarea>' +
        '<button class="lgt__btn lgt__btn--ghost" type="button" data-copy="text">' + esc(t('common.copy')) + '</button>' +
        upsell(t('garantia.upsell_title'), t('garantia.upsell_text'), APPS.guarantee);
      out.querySelector('[data-html]').value = htmlCode;
      out.querySelector('[data-text]').value = textoPlano;
      out.querySelectorAll('[data-copy]').forEach(function (b) {
        b.addEventListener('click', function () { copiar(b, b.getAttribute('data-copy') === 'html' ? htmlCode : textoPlano); });
      });
    }
    pintar();
  }

  /* ---------- Calculadora del plazo de garantía legal por país ---------- */
  // Mismos datos que el generador y la app (data/garantia.json = app/lib/legal.ts de Garantía UE) más la regla de
  // segunda mano (campo used). El botón lleva a la ficha de la App Store con UTM (utm_content=calculadora-garantia-<idioma>).
  function plazo() {
    app.innerHTML = '<div class="lgt__msg">' + esc(t('common.loading')) + '</div>';
    api('/api/garantia.json?tool=plazo').then(function (d) {
      if (!d || !d.legal) throw new Error('datos');
      montarPlazo(d);
    }).catch(function () { app.innerHTML = '<div class="lgt__msg lgt__msg--err">' + esc(t('common.error_generic')) + '</div>'; });
  }
  function montarPlazo(d) {
    var base = LANG.split('-')[0], tx = d.texts[base] || d.texts.en;
    var paises = UE.concat(EEE).filter(function (cc) { return d.legal[cc]; }).sort(function (a, b) { return region(a).localeCompare(region(b), LANG); });
    var inicial = (location.hash.match(/^#([A-Z]{2})$/) || [])[1];
    if (paises.indexOf(inicial) < 0) inicial = PAIS_IDIOMA[base] || 'ES';
    var meses = function (n) { return n % 12 === 0 ? anios(tx, n / 12, LANG) : t('plazo.months', { n: n }); };
    var enlace = function (url, texto) { return url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener nofollow">' + esc(texto) + '</a>' : ''; };
    var store = 'https://apps.shopify.com/lg-eu-guarantee?locale=' + encodeURIComponent(base) +
      '&utm_source=lineagrafica&utm_medium=web&utm_campaign=guarantee&utm_content=calculadora-garantia-' + encodeURIComponent(base);
    app.innerHTML = '<div class="lgt__row"><div><label class="lgt__label" for="lgt-pais">' + esc(t('plazo.country')) + '</label><select id="lgt-pais">' +
      paises.map(function (cc) { return '<option value="' + cc + '"' + (cc === inicial ? ' selected' : '') + '>' + esc(region(cc)) + '</option>'; }).join('') + '</select></div>' +
      '<div><span class="lgt__label">' + esc(t('plazo.condition')) + '</span><div class="lgt__checks">' +
      '<label><input type="radio" name="lgt-estado" value="new" checked> ' + esc(t('plazo.new')) + '</label>' +
      '<label><input type="radio" name="lgt-estado" value="used"> ' + esc(t('plazo.used')) + '</label></div></div></div>' +
      '<div data-out aria-live="polite"></div>' +
      '<div class="lgt__upsell"><div><h3>' + esc(t('plazo.cta_title')) + '</h3><p>' + esc(t('plazo.cta_text')) + '</p></div>' +
      '<a class="lgt__btn" style="white-space:normal;text-align:center" href="' + esc(store) + '" data-cta="plazo">' + esc(t('plazo.cta_button')) + '</a></div>' +
      '<p class="lgt__disc">' + esc(t('plazo.disclaimer', { date: dia(d.revisado) })) + '</p>';
    function dia(iso) { try { return new Date(iso).toLocaleDateString(LANG, { dateStyle: 'long' }); } catch (e) { return iso; } }
    var sel = app.querySelector('#lgt-pais'), out = app.querySelector('[data-out]');
    function pintar() {
      var cc = sel.value, l = d.legal[cc], usado = app.querySelector('[name=lgt-estado]:checked').value === 'used', u = l.used || {};
      var cifra = l.years > 0 ? anios(tx, l.years, LANG) : t('plazo.none');
      var lineas = [];
      if (l.years <= 0) lineas.push(t('plazo.none_text'));
      if (usado) {
        if (u.agreement && u.months) { lineas.push(t('plazo.used_short', { min: meses(u.months) })); }
        else if (u.ok && u.agreement === false) lineas.push(t('plazo.used_same'));
        else lineas.push(t('plazo.used_unknown'));
      }
      if (l.proof) lineas.push(t('plazo.proof', { n: meses(l.proof) }));
      if (l.ok === false) lineas.push(t('garantia.unconfirmed'));
      var fuentes = [enlace(l.source, t('garantia.source')), enlace(l.lawUrl, t('garantia.law') + ': ' + l.law)];
      if (usado && u.source && u.source !== l.source) fuentes.push(enlace(u.source, t('plazo.used_source') + (u.article ? ': ' + u.article : '')));
      out.innerHTML = '<div><p class="lgt__label" style="margin:20px 0 4px">' + esc(t(usado ? 'plazo.result_used' : 'plazo.result_new', { country: region(cc) })) + '</p>' +
        '<p style="font-size:2em;font-weight:700;margin:0 0 8px">' + esc(cifra) + '</p>' +
        lineas.map(function (x) { return '<p style="margin:0 0 8px">' + esc(x) + '</p>'; }).join('') +
        '<ul style="margin:8px 0 0;padding-left:18px">' + fuentes.filter(Boolean).map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul></div>';
      try { history.replaceState(null, '', '#' + cc); } catch (e) {}
    }
    app.addEventListener('change', pintar);
    pintar();
  }

  if (tool === 'vies') vies();
  else if (tool === 'check') check();
  else if (tool === 'garantia') garantia();
  else if (tool === 'plazo') plazo();
})();
